import {useMemo} from 'react';
import {usePolling} from './usePolling';
import {getAccountStatus} from '../api/account';

export function useAccountStatus({enabled = true} = {}) {
    // Fetch once on mount; no background timer. Pages that need live updates
    // (e.g. MyContentPage) poll via refetch on their own cadence, and mutating
    // actions (purchase / subscribe / cancel) refetch explicitly.
    const {data, error, refetch} = usePolling(getAccountStatus, null, {enabled});

    return useMemo(() => ({
        skazkiCredits: data?.skazki_credits || 0,
        skazkiCreditsBreakdown: data?.skazki_credits_breakdown || {subscription: 0, topup: 0, total: 0},
        subscription: data?.subscription || null,
        linkedTelegramId: data?.linked_telegram_id || null,
        linkedMaxId: data?.linked_max_id || null,
        skazkiHistory: data?.skazki_generations || [],
        error,
        refetch,
    }), [data, error, refetch]);
}
